import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Descriptions, Alert } from 'antd';
import * as productClassService from 'redux/services/productClass';
import { handleErrors } from 'Utils/errorHandler';

export default () => {
  const [productClass, setProductClass] = useState({});
  const [globalErrors, setGlobalErrors] = useState([]);
  const history = useHistory();
  const { classId } = useParams();

  useEffect(() => {
    (async () => {
      try {
        setProductClass(await productClassService.findById(classId));
      } catch (err) {
        setGlobalErrors(handleErrors(err, history));
      }
    })();
  }, [classId, history]);

  return (
    <div>
      <h2 className="page-title">Product Class: {productClass.name}</h2>
      {globalErrors.length > 0 && (
        <Alert type="error" showIcon description={<ul>{globalErrors.map((e, i) => <li key={i}>{e}</li>)}</ul>} />
      )}
      <Descriptions bordered size="small" column={2}>
        <Descriptions.Item label="Name">{productClass.name}</Descriptions.Item>
        <Descriptions.Item label="Description">{productClass.description}</Descriptions.Item>
        <Descriptions.Item label="Default">{productClass.isDefault ? 'Yes' : 'No'}</Descriptions.Item>
      </Descriptions>
      <Link to={`/catalog/productClass/edit/${productClass.id}/`}>edit</Link>
    </div>
  );
};
